import './index.css';

export default {
  name: 'Adropdown',
  props: {
    trigger: { type: String, default: () => 'click' },
    splitButton: { type: Boolean, default: () => false },
    size: { type: String, default: () => 'default' },
    icon: { type: String, default: () => '' },
    text: { type: String, default: () => '下拉菜单' },
    layout: { type: String, default: () => '' },
    username: { type: String, default: () => '' },
    data: {
      type: Array,
      default: () => [
        { text: '选项一', path: '', icon: 'el-icon-plus' },
        { text: '选项二', path: '', icon: 'el-icon-circle-plus' },
        { text: '选项三', path: '', icon: 'el-icon-circle-plus-outline' },
        { text: '选项四', path: '', icon: 'el-icon-check' },
        { text: '选项五', path: '', icon: 'el-icon-circle-check' },
      ]
    },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  data() {
    return {
      opened: false,
    }
  },
  methods: {
    click(e) { this.$emit('click', e) },
    command(e) { this.$emit('command', e) },
    visibleChange(e) {
      this.opened = e;
      this.$emit('visibleChange', e);
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div class={['a-dropdown', (this.opened ? 'opened' : null)]} style={{ color: this.color, ...this.style }}>
        {this.username && this.username != '' && (<span class="username">{this.username}</span>)}
        {this.icon && this.icon != '' && (
          <span class="usericon">
            <span class="icon">
              <img src={this.icon} />
            </span>
          </span>
        )}
        <el-dropdown
          class={this.layout == 'horizontal' ? 'horizontal' : null}
          size={this.size}
          trigger={this.trigger}
          split-button={this.splitButton}
          on-visible-change={e => this.visibleChange(e)}
          on-command={e => this.command(e)}
          on-click={e => this.click(e)}
          {...{ attrs }}
        >
          <span class="el-dropdown-link">
            {this.text}
            <i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            {data.length > 0 && data.map((a, b) => (
              <el-dropdown-item key={b} icon={a.icon} command={a} {...{ props: a }}>
                {a.rander ? () => a.rander() : a.text}
              </el-dropdown-item>
            ))}
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    );
  }
}